module.exports = __webpack_public_path__ + "static/img/banner-1.04e9d49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-1.png
// module id = ggUu
// module chunks = 1